import { api } from "@/api/client";
import type {
  PageInfo,
  UserCreateRequest,
  UserDetail,
  UserSummary,
  UserUpdateRequest,
} from "@/types/api";

export async function listUsers(): Promise<UserSummary[]> {
  const { data } = await api.get<UserSummary[]>("/admin/users");
  return data;
}

export async function getUser(id: number): Promise<UserDetail> {
  const { data } = await api.get<UserDetail>(`/admin/users/${id}`);
  return data;
}

export async function createUser(payload: UserCreateRequest): Promise<UserDetail> {
  const { data } = await api.post<UserDetail>("/admin/users", payload);
  return data;
}

export async function updateUser(id: number, payload: UserUpdateRequest): Promise<UserDetail> {
  const { data } = await api.put<UserDetail>(`/admin/users/${id}`, payload);
  return data;
}

export async function deleteUser(id: number): Promise<void> {
  await api.delete(`/admin/users/${id}`);
}

export async function getAvailablePages(): Promise<PageInfo[]> {
  const { data } = await api.get<PageInfo[]>("/admin/available-pages");
  return data;
}
